import { TransposeWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Transpose')
export class TransposeNodeSchemaProvider extends SchemaProvider<TransposeWorkflowNode> {}
